import "./sellscreendialogs.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import { type SaleEmailReceiptOptions } from "../../../Actions/SellScreen/SellScreenActions";
import Button from "../../../Common/Buttons/Button";
import { type InjectedDataSourceProps, withDataSource } from "../../../Data/DataStores/WithDataSource";
import { upload } from "../../../Workers/Upload/UploadAgent";
import { UPLOAD_TYPES } from "../../../Workers/Upload/UploadEvents";

const connector = connect();

interface Props extends ConnectedProps<typeof connector>, InjectedDataSourceProps {
    dispatch: ThunkDispatch<any, any, any>;
    options: SaleEmailReceiptOptions;
}

class RequestEmailUpdate extends React.Component<Props> {
    protected updateEmail = (): Promise<void> => {
        this.props.dispatch(hideDialog());

        return this.props.data
            .then(source => {
                return source.customers.get(this.props.options.customer as string)
                    .then(customer => {
                        return source.customers.put({
                            ...customer,
                            billing: {
                                ...customer.billing,
                                email: this.props.options.email,
                            },
                        });
                    });
            })
            .catch(err => {
                console.error("Could not update a local customer's email address", err);
            })
            .then(() => {
                return upload(UPLOAD_TYPES.UPDATE_CUSTOMER, {
                    customerId: this.props.options.customer as string,
                    email     : this.props.options.email,
                });
            });
    };

    protected cancelRequest = (): void => {
        this.props.dispatch(hideDialog());
    };

    public render(): React.ReactNode {
        return (
            <div className="request-email-update">
                <p>Update the users email to be {this.props.options.email}?</p>
                <div className="buttons">
                    <Button type="button" classes={[ "button-cancel" ]} onClick={this.cancelRequest}>No</Button>
                    <Button focus type="button" classes={[ "button-primary" ]} onClick={this.updateEmail}>Yes</Button>
                </div>
            </div>
        );
    }
}

export default connector(withDataSource(RequestEmailUpdate));
